import { UseQueryOptions } from 'react-query'
import { AIJobStatus, BrandKit } from 'types'
import { useBrandKits } from 'hooks/queries/brandKits/useBrandKits'

export const useCompletedBrandKits = (options?: Omit<UseQueryOptions<BrandKit[]>, 'select'>) =>
  useBrandKits({
    select: (data) => data.filter((brandKit) => brandKit.status === AIJobStatus.Successful),
    ...options,
  })
